<template>
  <router-link
    v-if="mobile !== true"
    :to="to"
    active-class="textHeadline5"
    class="inline-flex items-center text-textHeadline6"
  >
    <span class="flex items-center">
      <div
        v-if="
          currentPath == to ||
          navbarCategory === navbarStore.getActiveNavigationCategory
        "
        class="h-11 bg-white rounded-full flex items-center justify-center pr-3 pl-2 border border-light-gray"
      >
        <component :is="icon" class="h-8 w-8 p-1 mr-1" />
        {{ t(translationKey) }}
      </div>
      <div
        v-else
        class="h-11 w-11 bg-white rounded-full flex items-center justify-center"
      >
        <component :is="icon" class="h-6 w-6" />
      </div>
    </span>
  </router-link>
  <router-link
    v-else
    :to="to"
    active-class="textHeadline5"
    class="block px-3 py-1.5 rounded-md text-base text-textHeadline6"
  >
    {{ $t(translationKey) }}
  </router-link>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import { ref, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { useNavbarStore } from "../../../store/v2/navbar";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const route = useRoute();
const currentPath = ref(route.path);
const navbarStore = useNavbarStore();

watch(
  () => route.path,
  (newPath, oldPath) => {
    currentPath.value = newPath;
  }
);

defineProps({
  translationKey: {
    type: String,
    required: true,
  },
  to: {
    type: String,
    required: true,
  },
  mobile: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: Object as PropType<Record<string, any>>,
    default: () => ({}),
  },
  navbarCategory: {
    type: String,
  },
});
</script>
